/* =====================================================================
 * Natu.care — VWO event tracker (custom funnel events)
 * ---------------------------------------------------------------------
 * Served from the theme on all product pages (VWO sitewide custom JS is
 * not available on the current plan). Source mirror: vwo/events-tracker.js.
 *
 * Scope = ONLY the events that native VWO goals + the VWO Shopify app
 * can't capture. Everything else is configured VWO-side (see below).
 *
 * Fires (create matching custom-event metrics in VWO, account 923539):
 *   atcOnetime          main "Dodaj do koszyka", one-time purchase
 *   atcSubscription     main "Dodaj do koszyka", subscription
 *   addToCart          roll-up of both (prop: mode = onetime|subscription)
 *   upsellAddProtokol  "Protokół" (AOV v2/v3) add
 *   upsellAddMatchbox  "Doskonałe połączenia" (Rebuy matchbox) add
 *   upsellAdd           roll-up of both upsells (prop: source)
 *
 * NOT here — configure VWO-side instead:
 *   view_product    -> VWO goal: URL contains "/products/"
 *   start_checkout  -> VWO click goal: ".rebuy-cart__checkout-button, button[name=\"checkout\"]"
 *   checkout_complete + revenue -> VWO Shopify app (order/revenue tracking)
 *
 * Why these stay custom: the one-time vs subscription split depends on the
 * selling_plan hidden value at click time, which a CSS-selector click goal
 * can't read; the upsells are kept as reusable, attributed metrics.
 *
 * Idempotent. QA: ?natu_vwo_debug=1 logs every fire. Kill switch: ?natu_vwo_off=1.
 * ===================================================================== */
(function () {
  if (window.__natuVwoEvents) return;
  if (/[?&]natu_vwo_off=1/.test(location.search)) return;
  window.__natuVwoEvents = true;

  var DEBUG = /[?&]natu_vwo_debug=1/.test(location.search);

  /* ---- emit to VWO (Async SmartCode V3) + mirror to dataLayer ---- */
  function track(name, props) {
    props = props || {};
    try {
      window.VWO = window.VWO || [];
      if (typeof window.VWO.event === 'function') window.VWO.event(name, props);
      else window.VWO.push(['event', name, props]);
    } catch (e) {}
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'natu_' + name, natu: props });
    } catch (e) {}
    if (DEBUG) console.log('[natu-vwo]', name, props);
  }

  /* ---- de-dupe (guards double clicks + bubbling) ---- */
  var last = {};
  function once(key, ms) {
    var t = +new Date();
    if (last[key] && t - last[key] < (ms || 800)) return false;
    last[key] = t;
    return true;
  }

  function handle() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]).replace(/^c-/, '') : '';
  }

  /* one-time vs subscription = selling_plan value at click time is the truth.
     Prefer the clicked button's own form (what actually gets posted). */
  function purchaseMode(btn) {
    var form = btn && (btn.form || btn.closest('form'));
    var sp = (form && form.querySelector('input[name="selling_plan"]')) ||
             document.querySelector('.nc-product-buy-button input[name="selling_plan"]') ||
             document.querySelector('product-form input[name="selling_plan"]') ||
             document.querySelector('input[name="selling_plan"]');
    if (sp) return (sp.value && String(sp.value).trim() !== '') ? 'subscription' : 'onetime';
    /* product without selling plans → onetime, unless a sub tab is selected */
    return document.querySelector('.purchase-options_tab--subscription.purchase-options_tab--selected')
      ? 'subscription' : 'onetime';
  }

  /* Delegated, capture phase = fires before Rebuy/Vue/theme handlers. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    /* Protokół upsell (AOV v2 + v3). The "W koszyku" state is a <span> with no
       data-aov-add, so only real add buttons match. */
    var protokol = t.closest('.aov-pdp-v2__protokol-add[data-aov-add], .aov-pdp-v3__protokol-add[data-aov-add]');
    if (protokol && !protokol.disabled &&
        !protokol.classList.contains('aov-pdp-v2__protokol-add--in-cart') &&
        !protokol.classList.contains('aov-pdp-v3__protokol-add--in-cart')) {
      var h = protokol.getAttribute('data-aov-add') || '';
      if (once('protokol:' + h)) {
        track('upsellAddProtokol', { handle: h });
        track('upsellAdd', { source: 'protokol', handle: h });
      }
      return;
    }

    /* Doskonałe połączenia (Rebuy matchbox) */
    var matchbox = t.closest('.nc-product-rebuy-cross-sell--matchbox .nc-product-rebuy-cross-sell__button');
    if (matchbox && !matchbox.disabled) {
      if (once('matchbox')) {
        track('upsellAddMatchbox', {});
        track('upsellAdd', { source: 'matchbox' });
      }
      return;
    }

    /* Main add to cart — split by purchase mode (the native-impossible bit) */
    var atc = t.closest('.nc-product-buy-button .product-form__submit, product-form .product-form__submit');
    if (atc && !atc.disabled && atc.getAttribute('aria-disabled') !== 'true') {
      if (once('atc')) {
        var mode = purchaseMode(atc);
        track(mode === 'subscription' ? 'atcSubscription' : 'atcOnetime', { handle: handle() });
        track('addToCart', { mode: mode, handle: handle() });
      }
      return;
    }
  }, true);
})();
